:host([size='xl']) {
  @apply text-[56px] not-italic font-semibold leading-[64px];
}

:host([size='l']) {
  @apply text-5xl not-italic font-semibold leading-[56px];
}

:host([size='m']) {
  @apply text-[40px] not-italic font-semibold leading-[48px];
}

:host([size='s']) {
  @apply text-[32px] not-italic font-semibold leading-10;
}

:host([size='xs']) {
  @apply text-[26px] not-italic font-semibold leading-8;
}

:host([color='accent']) {
  @apply text-on-accent;
}

:host([color='primary']) {
  @apply text-on;
}
